"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickinessHighchartsSettingsChartTypeComponent = void 0;
const React = __importStar(require("react"));
const antd_1 = require("antd");
const icons_1 = require("@ant-design/icons");
const lodash_1 = __importDefault(require("lodash"));
const use_custom_compare_1 = require("use-custom-compare");
const StickinessPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/StickinessPageDataProvider");
const StickinessChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/stickiness/model/StickinessChartSettingsJSONModel");
const StickinessHighchartsSettingsChartTypeComponent = () => {
    const stickinessPageDataContext = (0, StickinessPageDataProvider_1.useStickinessPageDataContext)();
    const onRadioChange = (0, use_custom_compare_1.useCustomCompareCallback)((e) => {
        const value = e.target.value;
        const chartSettingsJSONModel = stickinessPageDataContext.stateFns.getURLJSONModel().getChartSettingsJSONModel();
        chartSettingsJSONModel.setChartType(value);
        stickinessPageDataContext.stateFns.onChartSettingsChanged(chartSettingsJSONModel.serialize());
    }, [stickinessPageDataContext.stateFns], lodash_1.default.isEqual);
    const { inProgress, loaded } = stickinessPageDataContext.state.status;
    const { isError } = stickinessPageDataContext.state.error;
    const chartType = stickinessPageDataContext.stateFns.getURLJSONModel().getChartSettingsJSONModel().getChartType();
    const disabled = inProgress || isError || !loaded || lodash_1.default.isNil(stickinessPageDataContext.state.data);
    return React.createElement(antd_1.Radio.Group, { value: chartType, size: "middle", disabled: disabled, optionType: "button", buttonStyle: "solid", onChange: onRadioChange },
        React.createElement(antd_1.Radio.Button, { value: StickinessChartSettingsJSONModel_1.ChartType.classic },
            React.createElement(icons_1.LineChartOutlined, null)),
        React.createElement(antd_1.Radio.Button, { value: StickinessChartSettingsJSONModel_1.ChartType.overtime },
            React.createElement(icons_1.FieldTimeOutlined, null)));
};
exports.StickinessHighchartsSettingsChartTypeComponent = StickinessHighchartsSettingsChartTypeComponent;
